import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

export const useWideStatusBarStyles = makeStyles((theme: DSTheme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '415px',
  },

  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '360px',
  },

  step: {
    textAlign: 'center',
    width: '20px',
    position: 'relative',
  },

  bullet: {
    backgroundColor: theme.palette.grey[600],
    borderRadius: '8px',
    height: '16px',
    width: '16px',
    color: theme.palette.grey[600],
    display: 'inline-block',
    lineHeight: '20px',

    '& p': {
      position: 'relative',
      top: '20px',
      left: '-10px',
    },

    '&.completed': {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.main,

      '&.hasNext::after': {
        backgroundImage: `linear-gradient(to right, ${theme.palette.success.main}, ${theme.palette.grey[600]})`,
      },
    },

    '&.hasNext::after': {
      content: '""',
      position: 'absolute',
      bottom: '8px',
      height: '1px',
      marginLeft: '6px',
      width: '100px',
      backgroundColor: theme.palette.grey[600],
    },
  },
}));

export const useStatusBarStyles = makeStyles((theme: DSTheme) => ({
  statusRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '11px 0',
  },
  statusContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '40%',
    marginRight: '5px',
  },
  step: {
    textAlign: 'center',
    width: '20%',
    position: 'relative',
  },
  bulletSmall: {
    backgroundColor: theme.palette.grey[600],
    borderRadius: '10px',
    height: '11px',
    width: '11px',
    color: theme.palette.grey[600],
    display: 'inline-block',
    lineHeight: '20px',

    '&.current': {
      backgroundColor: theme.palette.text.primary,
    },

    '&.hasNext::after': {
      content: '""', // content requires double-quotes to display correct.
      position: 'absolute',
      bottom: '9px',
      height: '1px',
      backgroundColor: theme.palette.grey[600],
      marginLeft: '6px',
      width: '14px',
    },
  },
}));
